module.exports = "<div #widgetContainer></div>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/core/components/resource-wizard/resource-wizard.component.html
// module id = ../../../../../src/app/modules/core/components/resource-wizard/resource-wizard.component.html
// module chunks = main